// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import { ServiceResource } from '../../SagaSchema/ServiceResource';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class ScheduledServiceResource_abstract extends ServiceResource {
  static $t: string = 'SagaSchema.ScheduledServiceResource';
  $t: string = 'SagaSchema.ScheduledServiceResource';

  public static GetMembers(): string[] {
    return [].concat(ServiceResource.GetMembers());
  }

  public GetMembers(): string[] {
    return ScheduledServiceResource_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  components(): string[] {
    return [
      'SagaSchema.Actor',
      'SagaSchema.Person',
      'SagaSchema.UriDocument',
      'SagaSchema.Vehicle',
      'SagaBase.Sector',
      'SagaSchema.ResourceServiceSchedule',
      'SagaSchema.ResourceTypeManager',
      'SagaSchema.Office',
      'SagaSchema.CommunicationEquipment'
    ];
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
